import React, { createContext, useContext, useState } from "react";

const translations = {
  en: {
    home: "Home", explore: "Explore", events: "Events", about: "About",
    signIn: "Sign In", joinFree: "Join Free",
    trustBusinesses: "Local businesses listed", trustReviews: "Reviews from locals", trustVerified: "Verified businesses",
    featuredPlaces: "Featured Places", topRated: "Top Rated", recentlyAdded: "Recently Added",
    searchPlaceholder: "Search restaurants, hotels, services...",
    placesFound: "places found", searching: "Searching...",
    filters: "Filters", resetAll: "Reset all",
    category: "Category", allCategories: "All categories",
    location: "Location", allLocations: "All locations",
    minRating: "Minimum Rating", andUp: "& up",
    priceRange: "Price Range", openNow: "Open now", verifiedOnly: "Verified only",
    noPlacesFound: "No places found", noPlacesDesc: "Try adjusting your search terms or filters.",
    clearFilters: "Clear filters",
    newest: "Newest", topRatedSort: "Top Rated", mostReviewed: "Most Reviewed", nameAZ: "Name A-Z",
    open: "Open", closed: "Closed", reviews: "reviews",
    writeReview: "Write Review", save: "Save", share: "Share", verified: "Verified",
    aboutTab: "About", menuTab: "Menu", photosTab: "Photos",
    cuisine: "Cuisine", amenities: "Amenities & Features", hours: "Hours",
    locationLabel: "Location", visitWebsite: "Visit Website",
    claimListing: "Claim this listing", isYourBusiness: "Is this your business?",
    similarNearby: "Similar Nearby Places",
    noReviews: "No reviews yet. Be the first to review!", noPhotos: "No photos yet.",
    monday: "Monday", tuesday: "Tuesday", wednesday: "Wednesday", thursday: "Thursday",
    friday: "Friday", saturday: "Saturday", sunday: "Sunday",
    subscriptionPlan: "Subscription Plan", currentPlan: "Current Plan",
    freePlan: "Free", basicPlan: "Basic", proPlan: "Pro", premiumPlan: "Premium",
    upgradePlan: "Upgrade Plan", currentPlanLabel: "Current", perMonth: "/month",
    verificationTitle: "Business Verification",
    verificationDesc: "Verified businesses get a badge and appear higher in search results.",
    requestVerification: "Request Verification", verificationPending: "Verification Pending", alreadyVerified: "Already Verified",
    dangerZone: "Danger Zone", deleteBusinessDesc: "Permanently delete your business listing and all associated data.",
    deleteBusiness: "Delete Business",
    plan_free_f1: "1 business listing", plan_free_f2: "Basic profile", plan_free_f3: "Customer reviews",
    plan_basic_f1: "3 business listings", plan_basic_f2: "Photo gallery", plan_basic_f3: "Menu/services section", plan_basic_f4: "Analytics",
    plan_pro_f1: "10 business listings", plan_pro_f2: "Featured placement", plan_pro_f3: "Priority support", plan_pro_f4: "Team members",
    plan_premium_f1: "Unlimited listings", plan_premium_f2: "Top placement", plan_premium_f3: "Dedicated support", plan_premium_f4: "Custom branding",
    cat_restaurant: "Restaurants", cat_cafe: "Cafes", cat_bakery: "Bakeries", cat_eatery: "Eateries",
    cat_bar: "Bars & Nightlife", cat_hotel: "Hotels", cat_guesthouse: "Guest Houses", cat_lodge: "Lodges", cat_inn: "Inns & B&Bs",
    cat_bank: "Banks", cat_pharmacy: "Pharmacies", cat_hospital: "Hospitals", cat_clinic: "Clinics",
    cat_nursery_school: "Nursery Schools", cat_primary_school: "Primary Schools", cat_secondary_school: "Secondary Schools",
    cat_university: "Universities", cat_training_institute: "Training Institutes",
    cat_supermarket: "Supermarkets", cat_electronics_store: "Electronics", cat_clothing_store: "Clothing", cat_market: "Markets",
    cat_beach: "Beaches", cat_park: "Parks", cat_attraction: "Attractions",
    cat_salon: "Salons & Spas", cat_gym: "Fitness", cat_service: "Other Services", cat_other: "Other",
    showMore: "Show more", showLess: "Show less", categories: "Categories", selected: "selected",
    linkCopied: "Link copied!", savedToList: "Saved to your list!",
    deals: "Deals",
  },
  fr: {
    home: "Accueil", explore: "Explorer", events: "Événements", about: "À propos",
    signIn: "Connexion", joinFree: "S'inscrire",
    trustBusinesses: "Entreprises locales listées", trustReviews: "Avis de locaux", trustVerified: "Entreprises vérifiées",
    featuredPlaces: "Lieux en vedette", topRated: "Les mieux notés", recentlyAdded: "Récemment ajoutés",
    searchPlaceholder: "Chercher restaurants, hôtels, services...",
    placesFound: "lieux trouvés", searching: "Recherche...",
    filters: "Filtres", resetAll: "Réinitialiser",
    category: "Catégorie", allCategories: "Toutes catégories",
    location: "Localisation", allLocations: "Toutes les zones",
    minRating: "Note minimale", andUp: "& plus",
    priceRange: "Gamme de prix", openNow: "Ouvert maintenant", verifiedOnly: "Vérifiés uniquement",
    noPlacesFound: "Aucun lieu trouvé", noPlacesDesc: "Essayez d'ajuster vos termes ou filtres.",
    clearFilters: "Effacer les filtres",
    newest: "Les plus récents", topRatedSort: "Les mieux notés", mostReviewed: "Les plus commentés", nameAZ: "Nom A-Z",
    open: "Ouvert", closed: "Fermé", reviews: "avis",
    writeReview: "Écrire un avis", save: "Sauvegarder", share: "Partager", verified: "Vérifié",
    aboutTab: "À propos", menuTab: "Menu", photosTab: "Photos",
    cuisine: "Cuisine", amenities: "Équipements", hours: "Horaires",
    locationLabel: "Localisation", visitWebsite: "Visiter le site",
    claimListing: "Revendiquer cette fiche", isYourBusiness: "C'est votre entreprise?",
    similarNearby: "Lieux similaires à proximité",
    noReviews: "Pas encore d'avis. Soyez le premier!", noPhotos: "Pas encore de photos.",
    monday: "Lundi", tuesday: "Mardi", wednesday: "Mercredi", thursday: "Jeudi",
    friday: "Vendredi", saturday: "Samedi", sunday: "Dimanche",
    subscriptionPlan: "Plan d'abonnement", currentPlan: "Plan actuel",
    freePlan: "Gratuit", basicPlan: "Basique", proPlan: "Pro", premiumPlan: "Premium",
    upgradePlan: "Mettre à niveau", currentPlanLabel: "Actuel", perMonth: "/mois",
    verificationTitle: "Vérification d'entreprise",
    verificationDesc: "Les entreprises vérifiées obtiennent un badge et apparaissent plus haut dans les résultats.",
    requestVerification: "Demander la vérification", verificationPending: "Vérification en attente", alreadyVerified: "Déjà vérifié",
    dangerZone: "Zone de danger", deleteBusinessDesc: "Supprimer définitivement votre entreprise et toutes les données associées.",
    deleteBusiness: "Supprimer l'entreprise",
    plan_free_f1: "1 fiche d'entreprise", plan_free_f2: "Profil de base", plan_free_f3: "Avis clients",
    plan_basic_f1: "3 fiches d'entreprise", plan_basic_f2: "Galerie photos", plan_basic_f3: "Section menu/services", plan_basic_f4: "Analyses",
    plan_pro_f1: "10 fiches d'entreprise", plan_pro_f2: "Mise en avant", plan_pro_f3: "Support prioritaire", plan_pro_f4: "Membres d'équipe",
    plan_premium_f1: "Fiches illimitées", plan_premium_f2: "Placement en tête", plan_premium_f3: "Support dédié", plan_premium_f4: "Marque personnalisée",
    cat_restaurant: "Restaurants", cat_cafe: "Cafés", cat_bakery: "Boulangeries", cat_eatery: "Gargotes",
    cat_bar: "Bars & Boîtes", cat_hotel: "Hôtels", cat_guesthouse: "Maisons d'hôtes", cat_lodge: "Lodges", cat_inn: "Auberges",
    cat_bank: "Banques", cat_pharmacy: "Pharmacies", cat_hospital: "Hôpitaux", cat_clinic: "Cliniques",
    cat_nursery_school: "Garderies", cat_primary_school: "Écoles primaires", cat_secondary_school: "Collèges/Lycées",
    cat_university: "Universités", cat_training_institute: "Instituts de formation",
    cat_supermarket: "Supermarchés", cat_electronics_store: "Électronique", cat_clothing_store: "Vêtements", cat_market: "Marchés",
    cat_beach: "Plages", cat_park: "Parcs", cat_attraction: "Attractions",
    cat_salon: "Salons & Spas", cat_gym: "Fitness", cat_service: "Autres services", cat_other: "Autre",
    showMore: "Voir plus", showLess: "Voir moins", categories: "Catégories", selected: "sélectionné(s)",
    linkCopied: "Lien copié!", savedToList: "Sauvegardé!",
    deals: "Offres",
  },
};

export const LangContext = createContext({ lang: "en", t: (k) => k, setLang: () => {} });

export function LangProvider({ children }) {
  const [lang, setLang] = useState(() => {
    try { return localStorage.getItem("chosaan_lang") || "en"; } catch { return "en"; }
  });
  const t = (key) => translations[lang]?.[key] || translations.en?.[key] || key;
  const changeLang = (l) => { setLang(l); try { localStorage.setItem("chosaan_lang", l); } catch {} };
  return <LangContext.Provider value={{ lang, t, setLang: changeLang }}>{children}</LangContext.Provider>;
}

export function useLang() {
  return useContext(LangContext);
}